'use client'

import { useMemoryCleanup } from 'composition/memoryCleanup/useMemoryCleanup'

/**
 * Component that handles memory cleanup initialization
 * Must be rendered inside QueryClientProvider
 */
const MemoryCleanupProvider = () => {
  // Hook already has internal checks for browser environment
  useMemoryCleanup()

  return null
}

export default MemoryCleanupProvider
